import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { facturacionAPI } from '../services/api';
import '../Clientes.css';
import './DiagnosticoArca.css';

const ESTADOS = {
  ok: { icono: '✓', texto: 'Correcto' },
  aviso: { icono: '!', texto: 'Atención' },
  error: { icono: '✕', texto: 'Error' },
  omitido: { icono: '–', texto: 'No probado' },
};

const RESUMEN = {
  ok: 'Todo correcto: el sistema puede facturar con ARCA.',
  aviso: 'Se puede facturar, pero hay puntos para revisar.',
  error: 'Hay errores: el sistema no va a poder facturar hasta corregirlos.',
};

function fechaHora(iso) {
  return new Date(iso).toLocaleString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires', hourCycle: 'h23' });
}

function textoParaCopiar(diagnostico) {
  const lineas = [
    `Diagnóstico ARCA · ${fechaHora(diagnostico.fecha)} · ${diagnostico.entorno} · CUIT ${diagnostico.cuit || '—'}`,
    RESUMEN[diagnostico.resultado],
    '',
  ];
  for (const p of diagnostico.pasos) {
    lineas.push(`[${ESTADOS[p.estado].texto}] ${p.titulo}: ${p.resumen}`);
    p.detalles.forEach((d) => lineas.push(`   - ${d}`));
    if (p.ayuda) lineas.push(`   Qué hacer: ${p.ayuda}`);
  }
  return lineas.join('\n');
}

const DiagnosticoArca = () => {
  const [diagnostico, setDiagnostico] = useState(null);
  const [probando, setProbando] = useState(false);

  const ejecutar = async () => {
    setProbando(true);
    try {
      const res = await facturacionAPI.diagnostico();
      if (!res.success) throw new Error(res.message || 'No se pudo ejecutar el diagnóstico');
      setDiagnostico(res.data);
    } catch (error) {
      toast.error(error.message || 'No se pudo ejecutar el diagnóstico');
    } finally {
      setProbando(false);
    }
  };

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(textoParaCopiar(diagnostico));
      toast.success('Resultado copiado');
    } catch {
      toast.error('No se pudo copiar');
    }
  };

  return (
    <div className="clientes diagnostico-arca">
      <div className="page-header">
        <h1>Conexión con ARCA</h1>
        <div className="diagnostico-arca-acciones">
          {diagnostico && (
            <button type="button" className="btn-secondary" onClick={copiar}>Copiar resultado</button>
          )}
          <button type="button" className="btn-primary" onClick={ejecutar} disabled={probando}>
            {probando ? 'Probando…' : diagnostico ? 'Volver a probar' : 'Probar conexión'}
          </button>
        </div>
      </div>

      <p className="diagnostico-arca-intro">
        Revisa, en orden, los datos de Configuración General, las variables de entorno del servidor
        (certificado y clave), el estado de ARCA, la autenticación y el punto de venta. No emite
        comprobantes. El resultado queda registrado en Auditoría.
      </p>

      {probando && !diagnostico && <div className="loading">Consultando ARCA…</div>}

      {diagnostico && (
        <>
          <div className={`diagnostico-arca-resumen ${diagnostico.resultado}`} role="status">
            <strong>{RESUMEN[diagnostico.resultado]}</strong>
            <span>
              {diagnostico.entorno === 'produccion' ? 'Producción' : 'Homologación'} · CUIT {diagnostico.cuit || '—'} · {fechaHora(diagnostico.fecha)}
            </span>
          </div>

          <ol className="diagnostico-arca-pasos">
            {diagnostico.pasos.map((p) => (
              <li key={p.id} className={`diagnostico-arca-paso ${p.estado}`}>
                <span className="diagnostico-arca-icono" aria-label={ESTADOS[p.estado].texto}>{ESTADOS[p.estado].icono}</span>
                <div className="diagnostico-arca-cuerpo">
                  <div className="diagnostico-arca-titulo">
                    <h2>{p.titulo}</h2>
                    <span className="diagnostico-arca-estado">{ESTADOS[p.estado].texto}</span>
                  </div>
                  <p className="diagnostico-arca-texto">{p.resumen}</p>
                  {p.detalles.length > 0 && (
                    <ul className="diagnostico-arca-detalles">
                      {p.detalles.map((d) => <li key={d}>{d}</li>)}
                    </ul>
                  )}
                  {p.ayuda && (
                    <p className="diagnostico-arca-ayuda"><strong>Qué hacer:</strong> {p.ayuda}</p>
                  )}
                </div>
              </li>
            ))}
          </ol>
        </>
      )}
    </div>
  );
};

export default DiagnosticoArca;
